/* SOLSTEAD theme.js - back-button position (browser native), instant product pages (pre-load on touch / hover), gallery (swipe strip, thumbs, arrows, dots, preloading), shop menu, scroll-spy, size picker (price / size / gallery / DESCRIPTION swap), 13.75 oz free-mini add, cart stepper.
   Oct 14 2026 (his rulings): (1) BACK BUTTON - the old home-made scroll memory switched the browser's own memory off and,
   whenever the page address carried a section marker such as '/#quiet', skipped restoring altogether, so a shopper who went
   back from a product landed at the top (measured: left at 3,739px, came back to 0). The browser's own memory is now on again;
   it returns to the exact spot, including through the instant back cache. (2) NO FLIPPING - the scent cards are a plain photo
   and details, one link, so the flip code is gone. (3) LIGHTNING-FAST PRODUCT PAGES - the moment a finger touches a product
   link (or a mouse rests on it for a split second), the product page and its main photo start loading, so the page is ready
   when the tap lands.
   Oct 15 2026 (his ask: swiping and loading photos must be solid): (4) THE GALLERY IS A SWIPE STRIP - all photos sit side by side
   (snippets/product-gallery.liquid) and the finger drags them, snapping to one photo at a time, instead of the old 'lift the finger,
   then swap the picture' that felt like a delay. Arrows, dots and thumbnails move the strip. The next photos load ahead of the
   swipe, so none is ever waited for. (5) Instant product pages now warm the exact photo size the product page will pick
   (data-warm-srcset), so the first photo is already there when the page opens. */
(function () {
  /* ---- back button: the browser's own scroll memory (see header). ---- */
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'auto'; } catch (e) {}

  /* ---- instant product pages: pre-load the page and its main photo on first touch / hover. ---- */
  try {
    var warmedLinks = {};
    var warmLink = function (a) {
      var href = a.getAttribute('href') || '';
      if (!/^\/(products|collections)\//.test(href) || a.target || warmedLinks[href]) return;
      warmedLinks[href] = true;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = href;
      l.as = 'document';
      document.head.appendChild(l);
      var ss = a.getAttribute('data-warm-srcset');
      if (ss) {
        var wi = new Image(); wi.decoding = 'async';
        wi.sizes = a.getAttribute('data-warm-sizes') || '100vw';
        wi.srcset = ss;
      } else {
        var img = a.getAttribute('data-warm-img');
        if (img) { var im = new Image(); im.decoding = 'async'; im.src = img; }
      }
    };
    var linkFrom = function (e) { return e.target && e.target.closest && e.target.closest('a[href]'); };
    var hoverTimer = null;
    document.addEventListener('touchstart', function (e) { var a = linkFrom(e); if (a) warmLink(a); }, { passive: true });
    document.addEventListener('mouseover', function (e) {
      var a = linkFrom(e);
      if (!a) return;
      if (hoverTimer) clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { warmLink(a); }, 65);
    }, { passive: true });
    document.addEventListener('mouseout', function () { if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; } }, { passive: true });
  } catch (e) {}

  /* ---- product gallery: swipe strip + thumbs + arrows (computer) + dots (phone) + loading ahead ---- */
  var Gal = { go: function () {}, rebuild: function () {} };
  try {
    var galMain = document.querySelector('[data-gallery-main]');
    var track = galMain && galMain.querySelector('[data-gal-track]');
    if (track) {
      var prevBtn = galMain.querySelector('[data-gal-prev]');
      var nextBtn = galMain.querySelector('[data-gal-next]');
      var dotsWrap = galMain.querySelector('[data-gal-dots]');
      var thumbsWrap = document.querySelector('.gallery-thumbs');
      var cur = 0, ticking = false, target = -1, targetTimer = null;
      var slides = function () { return track.querySelectorAll('[data-gal-slide]'); };
      var thumbs = function () { return document.querySelectorAll('[data-gallery-thumb]'); };

      /* load the photo at i and the ones either side of it now, instead of waiting until they scroll into view */
      var warmAt = function (i) {
        var s = slides();
        [i - 1, i, i + 1, i + 2].forEach(function (k) {
          var el = s[(k + s.length) % s.length];
          var im = el && el.querySelector('img');
          if (im && im.loading !== 'eager') im.loading = 'eager';
        });
      };
      var paint = function (i) {
        cur = i;
        Array.prototype.forEach.call(thumbs(), function (b, k) { b.classList.toggle('active', k === i); });
        if (dotsWrap) Array.prototype.forEach.call(dotsWrap.children, function (d, k) { d.classList.toggle('active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      var go = function (i, smooth) {
        var n = slides().length;
        if (!n) return;
        i = ((i % n) + n) % n;
        warmAt(i);
        paint(i);
        /* while the strip glides to the chosen photo, the photos it passes are not marked as current (no flicker) */
        target = smooth === false ? -1 : i;
        if (targetTimer) clearTimeout(targetTimer);
        targetTimer = setTimeout(function () { target = -1; }, 900);
        var left = i * track.clientWidth;
        try { track.scrollTo({ left: left, behavior: smooth === false ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = left; }
      };
      var renderDots = function () {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var n = slides().length;
        if (n < 2) return;
        for (var k = 0; k < n; k++) {
          (function (k) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'gal-dot' + (k === cur ? ' active' : '');
            d.setAttribute('aria-label', 'Photo ' + (k + 1));
            d.addEventListener('click', function () { go(k); });
            dotsWrap.appendChild(d);
          })(k);
        }
      };
      var syncNav = function () {
        var many = slides().length > 1;
        if (prevBtn) prevBtn.hidden = !many;
        if (nextBtn) nextBtn.hidden = !many;
        if (thumbsWrap) thumbsWrap.hidden = !many;
        renderDots();
      };
      if (thumbsWrap) thumbsWrap.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('[data-gallery-thumb]');
        if (!b) return;
        var i = Array.prototype.indexOf.call(thumbs(), b);
        if (i > -1) go(i);
      });
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); go(cur - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); go(cur + 1); });
      /* the finger (or a trackpad) moves the strip; the photo nearest the middle becomes the current one */
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          if (target > -1) { if (i === target) target = -1; return; }
          if (i !== cur) { paint(i); warmAt(i); }
        });
      }, { passive: true });
      /* keep the current photo in place when the screen is turned or the window is resized */
      window.addEventListener('resize', function () { track.scrollLeft = cur * track.clientWidth; }, { passive: true });
      /* a finger on the strip always takes over from a glide in progress */
      track.addEventListener('touchstart', function () { target = -1; }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });
      /* loading ahead: the second photo as soon as the page has loaded, every other photo once the page is quiet */
      var warmAll = function () { Array.prototype.forEach.call(slides(), function (el) { var im = el.querySelector('img'); if (im) im.loading = 'eager'; }); };
      var afterLoad = function () {
        warmAt(0);
        if ('requestIdleCallback' in window) requestIdleCallback(warmAll, { timeout: 2500 }); else setTimeout(warmAll, 1200);
      };
      if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad);

      /* size picker: swap in the chosen size's photos (JSON from snippets/size-option.liquid) */
      var rebuild = function (media) {
        if (!media || !media.length) return;
        var sizes = (track.querySelector('img') && track.querySelector('img').getAttribute('sizes')) || '100vw';
        track.innerHTML = '';
        media.forEach(function (m, i) {
          var s = document.createElement('div');
          s.className = 'gal-slide';
          s.setAttribute('data-gal-slide', '');
          var im = document.createElement('img');
          im.alt = m.alt || '';
          im.width = m.w || 1200; im.height = m.h || 1200;
          im.decoding = 'async';
          im.loading = i < 2 ? 'eager' : 'lazy';
          if (i === 0) { try { im.fetchPriority = 'high'; } catch (e) {} }
          im.draggable = false;
          im.addEventListener('load', function () { s.classList.add('is-in'); });
          im.sizes = sizes;
          if (m.srcset) im.srcset = m.srcset;
          im.src = m.src;
          s.appendChild(im);
          track.appendChild(s);
        });
        if (thumbsWrap) {
          thumbsWrap.innerHTML = '';
          media.forEach(function (m, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('data-gallery-thumb', '');
            b.setAttribute('data-src', m.src);
            b.setAttribute('data-alt', m.alt || '');
            b.setAttribute('aria-label', 'View photo ' + (i + 1));
            var ti = document.createElement('img');
            ti.src = m.thumb; ti.alt = ''; ti.loading = 'lazy'; ti.width = 72; ti.height = 72;
            b.appendChild(ti);
            thumbsWrap.appendChild(b);
          });
        }
        cur = 0;
        track.scrollLeft = 0;
        syncNav();
        paint(0);
        if ('requestIdleCallback' in window) requestIdleCallback(warmAll, { timeout: 2500 }); else setTimeout(warmAll, 1200);
        try { document.dispatchEvent(new CustomEvent('gallery:rebuilt')); } catch (e) {}
      };

      syncNav();
      paint(0);
      Gal = { go: go, rebuild: rebuild };
      window.SolGallery = { go: go, index: function () { return cur; } };
    }
  } catch (e) {}

  /* ---- shop menu: close on outside click / escape ---- */
  try {
    var shopMenu = document.querySelector('[data-shop-menu]');
    if (shopMenu) {
      document.addEventListener('click', function (e) {
        if (shopMenu.open && !shopMenu.contains(e.target)) shopMenu.removeAttribute('open');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && shopMenu.open) shopMenu.removeAttribute('open');
      });
    }
  } catch (e) {}

  /* ---- free-mini options: mark the chosen one with a class ---- */
  try {
    var miniLabels = document.querySelectorAll('[data-mini-pick] .mp-opt');
    function paintMini() {
      Array.prototype.forEach.call(miniLabels, function (l) {
        var r = l.querySelector('input[name="free-mini"]');
        if (r && r.checked) l.classList.add('is-on'); else l.classList.remove('is-on');
      });
    }
    if (miniLabels.length) {
      paintMini();
      Array.prototype.forEach.call(miniLabels, function (l) {
        var r = l.querySelector('input[name="free-mini"]');
        if (r) r.addEventListener('change', paintMini);
      });
    }
  } catch (e) {}

  /* ---- size picker: one page per scent, three sizes, swap in place (price, size line, gallery, DESCRIPTION). ---- */
  try {
    var opts = document.querySelectorAll('[data-size-opt]');
    var formEl = document.querySelector('form[data-buy-form]');
    if (opts.length > 1 && formEl) {
      var idIn = formEl.querySelector('input[name="id"]');
      var addBtn = formEl.querySelector('button[name="add"]');
      var priceEl = document.querySelector('.buy-price');
      var subEl = document.querySelector('.buy-sub');
      var fitEl = document.querySelector('.fit-line');
      var pickEl = document.querySelector('[data-mini-pick]');
      var ritEl = document.querySelector('[data-ritual-invite]');
      var descEl = document.querySelector('[data-pd-desc]');

      function setGallery(vid) {
        var s = document.querySelector('script[data-size-media="' + vid + '"]');
        if (!s) return;
        var media;
        try { media = JSON.parse(s.textContent); } catch (e) { return; }
        Gal.rebuild(media);
      }

      function setDescription(vid) {
        if (!descEl) return;
        var tpl = document.querySelector('template[data-size-desc="' + vid + '"]');
        if (!tpl) return;
        descEl.innerHTML = tpl.innerHTML; /* server-rendered Shopify description for that size, never user input */
      }

      Array.prototype.forEach.call(opts, function (o) {
        o.addEventListener('click', function () {
          if (o.classList.contains('active')) return;
          Array.prototype.forEach.call(opts, function (x) { x.classList.remove('active'); x.setAttribute('aria-pressed', 'false'); });
          o.classList.add('active'); o.setAttribute('aria-pressed', 'true');
          var kind = o.getAttribute('data-kind');
          var avail = o.getAttribute('data-avail') === 'true';
          var vid = o.getAttribute('data-vid');
          if (idIn) idIn.value = vid;
          if (priceEl) priceEl.textContent = o.getAttribute('data-price');
          if (subEl) subEl.textContent = o.getAttribute('data-size') + ' · 100% natural soy wax · hand‑poured in the USA';
          if (fitEl) fitEl.textContent = o.getAttribute('data-fit');
          if (pickEl) pickEl.hidden = kind !== 'reserve';
          if (ritEl) ritEl.hidden = kind !== 'core';
          if (addBtn) { addBtn.disabled = !avail; addBtn.textContent = avail ? 'Add to evening →' : 'Sold out'; }
          setGallery(vid);
          setDescription(vid);
          var url = o.getAttribute('data-url');
          if (url && window.history && history.replaceState) history.replaceState(null, '', url);
        });
      });
    }
  } catch (e) {}

  /* ---- 13.75 oz: add the chosen free mini as a second line item ---- */
  try {
    var form = document.querySelector('form[data-buy-form]');
    var pick = document.querySelector('[data-mini-pick]');
    if (form && pick) {
      var errEl = document.querySelector('[data-buy-err]');
      form.addEventListener('submit', function (e) {
        if (pick.hidden) return;
        var picked = pick.querySelector('input[name="free-mini"]:checked');
        var idField = form.querySelector('input[name="id"]');
        if (!picked || !idField) return;
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        if (errEl) errEl.hidden = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [
            { id: Number(idField.value), quantity: 1 },
            { id: Number(picked.value), quantity: 1 }
          ] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/cart';
        }).catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          form.submit();
        });
      });
    }
  } catch (e) {}

  /* ---- cart: minus / plus / remove / typed quantity all save themselves, then the page refreshes ---- */
  try {
    var cartLines = document.querySelector('[data-cart-lines]');
    if (cartLines) {
      var cartErr = document.querySelector('[data-cart-err]');
      var busy = false;
      function changeLine(line, qty) {
        if (busy) return;
        busy = true;
        cartLines.classList.add('is-busy');
        if (cartErr) cartErr.hidden = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        }).then(function (r) {
          if (!r.ok) throw new Error('change failed');
          window.location.reload();
        }).catch(function () {
          busy = false;
          cartLines.classList.remove('is-busy');
          if (cartErr) cartErr.hidden = false;
        });
      }
      Array.prototype.forEach.call(cartLines.querySelectorAll('[data-line]'), function (row) {
        var line = Number(row.getAttribute('data-line'));
        var input = row.querySelector('[data-qty-input]');
        var minus = row.querySelector('[data-qty-minus]');
        var plus = row.querySelector('[data-qty-plus]');
        var remove = row.querySelector('[data-qty-remove]');
        function current() { var n = parseInt(input && input.value, 10); return isNaN(n) || n < 0 ? 0 : n; }
        if (minus) minus.addEventListener('click', function () { changeLine(line, Math.max(0, current() - 1)); });
        if (plus) plus.addEventListener('click', function () { changeLine(line, current() + 1); });
        if (remove) remove.addEventListener('click', function (e) { e.preventDefault(); changeLine(line, 0); });
        if (input) {
          input.addEventListener('change', function () { changeLine(line, current()); });
          input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); changeLine(line, current()); } });
        }
      });
    }
  } catch (e) {}

  /* ---- library scroll-spy ---- */
  try {
    var panels = document.querySelectorAll('[data-panel]');
    var links = document.querySelectorAll('.idx-link');
    if (panels.length && links.length && 'IntersectionObserver' in window) {
      var byHandle = {};
      Array.prototype.forEach.call(links, function (l) { byHandle[l.getAttribute('data-idx')] = l; });
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            Array.prototype.forEach.call(links, function (l) { l.classList.remove('active'); });
            var link = byHandle[en.target.getAttribute('data-panel')];
            if (link) link.classList.add('active');
          }
        });
      }, { rootMargin: '-35% 0px -55% 0px' });
      Array.prototype.forEach.call(panels, function (p) { obs.observe(p); });
    }
  } catch (e) {}
})();
